module.exports = __webpack_public_path__ + "static/media/fa-brands-400.1a575a41.woff";